import { useEffect, useState } from 'react'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

import './style.scss';
import { UserPost } from '../../types/posts';
import AppUserPost from '../../components/app_userPost/AppUserPost';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import AppPost from '../../components/app_post/AppPost';
import AppPostButton from '../../components/app_postButton/AppPostButton';
import { communityStateData } from '../../data/communityStateData';
import { postConnector } from '../../server/connector/postConnector';
import { communityConnector } from '../../server/connector/communityConnector';
import AppComment from '../../components/app_comment/AppComment';
import { setUserPosts } from '../../redux/reducers/postSlice';

function AppCommunity() {

	const showNewPost = useAppSelector((state) => state.user.showNewPost)
	const commentPost = useAppSelector((state) => state.post.commentPost)
	const dispatch = useAppDispatch()

	const [communityId, setCommunityId] = useState<string>('')
	const [communityName, setCommunityName] = useState<string>('')
	const [bioExpanded, setBioExpanded] = useState<boolean>(false)
	const [bioText, setBioText] = useState<string>('')
	const [communityTagLine, setCommunityTagLine] = useState<string>('')

	const [showingReels, setShowingReels] = useState<boolean>(true)

	// const [userPosts, setUserPosts] = useState<UserPost[]>([])
	const userPosts = useAppSelector(state => state.post.userPosts)

	const [isMemberOfCommunity, setIsMemberOfCommunity] = useState<boolean>(false)
	const [joinConnecting, setJoinConnecting] = useState<boolean>(false)

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn === false) {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		} else {
			// Load profile data
			// setBioText('Thisis the users Bio section where they can write a little about who they are. The text will appears cut off until it is expanded by clicking the show more button')
			getProfileData()
		}
	}, [])

	const getProfileData = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const communityId: string | null = urlParams.get('id')

		if (communityId) {
			setCommunityId(communityId)
			// communityStateData.userCommunities = []
			communityConnector.getCommunitiesForUserRequest(userStateData.getId()).then((successResponse) => {
				updateIsMember(communityId)
				// setUserCommunities(communityStateData.userCommunities)
			})
			setCommunityName(communityStateData.communities[parseInt(communityId) - 1].community_name)
			setBioText(communityStateData.communities[parseInt(communityId) - 1].community_description)
			setCommunityTagLine(communityStateData.communities[parseInt(communityId) - 1].community_tag_line)
		}
		// setCommunityName(communityName ? communityName : 'Community Name')
		// setBioText('This is an example Community about us text exntry used for testing data transfer and front-end layout')

		// setUserPosts(communityStateData.userPosts)
		communityStateData.userPosts = []
		dispatch(setUserPosts(communityStateData.userPosts))
		if (communityId !== null) {
			postConnector.getCommunityPostsRequest(communityId).then((successResponse) => {
				// setUserPosts(communityStateData.userPosts)
				dispatch(setUserPosts(communityStateData.userPosts))
			})
		}
	}

	const updateIsMember = (id: string) => {
		setIsMemberOfCommunity(userStateData.isMemberOfCommunity(id))
	}

	const joinCommunity = () => {
		setJoinConnecting(true)
		if (communityId) {
			communityConnector.joinCommunityRequest(communityId, userStateData.getId()).then((successResponse) => {
				userStateData.addCommunity(communityName, parseInt(communityId))
				updateIsMember(communityId)
				setJoinConnecting(false)
			})
		}
	}

	const leaveCommunity = () => {
		setJoinConnecting(true)
		if (communityId) {
			communityConnector.leaveCommunityRequest(communityId, userStateData.getId()).then((successResponse) => {
				userStateData.removeCommunity(parseInt(communityId))
				updateIsMember(communityId)
				setJoinConnecting(false)
			})
		}
	}

	return (
		<>
			<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space app-community-page-full-section'>
				<div className='app-community-page-top-section-wrap'>
					<div className='app-community-page-top-section'>
						<div className='app-community-page-top-section-hero-image' />
						<div
							className='app-community-page-img-wrap'
						>
							<img 
								className='app-community-page-img'
								src={'/imgs/temp/community/temp-icon.png'}
								alt='Profile'
							/>
						</div>
						<a
							href={PAGE_URLS.APP_COMMUNITIES}
							className='app-community-page-back-button'
						>
							<img
								src='/imgs/icons/shared/icon-instructor-shared-button.svg'
								alt='Back'
							/>
						</a>
					</div>
				</div>
				<div className='app-community-page-bio-section-wrap'>
					<div className='app-community-page-top-name-wrap'>
						<div className='app-community-page-top-name'>{communityName}</div>
					</div>
					<div className='app-community-page-friend-wrap'>
						{/* <div className='app-community-page-friend-icon' />
						<div className='app-community-page-friend-icon' />
						<div className='app-community-page-friend-icon' /> */}
						<div className='app-community-page-friend-label'>? + Members</div>
					</div>
					<div 
						className='app-community-page-tag-line'
					>{communityTagLine}</div>
					<div 
						className='app-community-page-bio-text'
					>
						{bioText.length > 1 ? 
							<>
								{bioExpanded ? bioText : `${bioText.substring(0, 20)} ... `}
								{bioExpanded === false && 
									<div 
										className='app-community-page-bio-show-more'
										onClick={() => {
											setBioExpanded(true)
										}}
									>see more</div>
								}
							</> :
							<>No Bio Provided</>
						}
					</div>
					<div className='app-community-page-action-button-wrap'>
						<button
							className='app-community-page-action-button'
							onClick={() => {
								if (isMemberOfCommunity) {
									leaveCommunity()
								} else {
									joinCommunity()
								}
							}}
							disabled={joinConnecting}
						>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src={isMemberOfCommunity ? '/imgs/icons/community/icon-community-leave.svg' : '/imgs/icons/community/icon-community-join.svg'}
									alt='Join'
								/>
							</div>
							<div 
								className={`app-community-page-action-button-label ${isMemberOfCommunity ? '' : 'app-community-page-action-button-label-branded'}`}
							>
								{joinConnecting ? '...' : isMemberOfCommunity ? 'Leave' : 'Join'}
							</div>
						</button>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-info.svg'
									alt='Info'
								/>
							</div>
							<div className='app-community-page-action-button-label'>Info</div>
						</div>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-share.svg'
									alt='Share'
								/>
							</div>
							<div className='app-community-page-action-button-label'>Share</div>
						</div>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-more.svg'
									alt='More'
								/>
							</div>
							<div className='app-community-page-action-button-label'>More</div>
						</div>
					</div>
					<div className='app-community-page-switch-wrap'>
						<div 
							className={`app-community-page-switch-button ${showingReels === true ? 'app-community-page-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(true)
							}}
						>
							<div
								className='app-community-page-switch-label'
							>Feed</div>
						</div>
						{/* <div className='app-community-page-switch-button'> */}
						<div 
							className={`app-community-page-switch-button ${showingReels === false ? 'app-community-page-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(false)
							}}
						>
							<div
								className='app-community-page-switch-label'
							>Groups</div>
						</div>
					</div>
				</div>
				<div className='app-community-page-content-section-wrap'>
					{showingReels ? 
						<>
							{userPosts.length > 0 ?
								userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
								:
								<div className='app-community-page-content-section-empty-text'>
									<div className='app-community-page-content-section-empty-text-title'>No post in the community yet...</div>
									<div className='app-community-page-content-section-empty-text-sub-text'>Get started by joining the community<br/>and tapping the post button!</div>
								</div>
							}
						</>
						:
						<div className='app-community-page-content-section-empty-text'>
							<div className='app-community-page-content-section-empty-text-title'>No posts from Owner yet...</div>
							<div className='app-community-page-content-section-empty-text-sub-text'>Check back later to see<br/>posts from this group!</div>
						</div>
					}
				</div>
			</div>
			<BackToTopButton />
			<AppPostButton />
			<AppFooter activeIndex={1} />
			{showNewPost && <AppPost />}
			{commentPost && <AppComment postData={commentPost} />}
		</>
	)
}

export default AppCommunity
